<template>
  <div>
    <div>Chi tiết đơn hàng</div>
    <DxDataGrid
        :column-auto-width="true"
        :data-source="dataSource"
        :show-borders="true"
    >
      <!--      <DxEditing-->
      <!--          mode="row"-->
      <!--          :use-icons="true"-->
      <!--          :allow-updating="true"-->
      <!--          :allow-deleting="true"-->
      <!--      />-->


      <DxColumn :allow-editing="false" caption="Mã chi tiết" data-field="Id" width="100"/>
      <DxColumn :allow-editing="false" caption="Số đặt mua" data-field="Msisdn"/>
      <DxColumn :allow-editing="false" caption="Giá số" data-field="Price"/>
      <DxColumn :allow-editing="false" caption="Giá SIM" data-field="SimPrice"/>
      <DxColumn :allow-editing="false" caption="Giá ESIM" data-field="EsimPrice"/>
      <DxColumn :allow-editing="false" caption="Giá gói" data-field="PackPrice"/>
      <DxColumn :allow-editing="false" caption="Cam kết" data-field="Months"/>
      <DxColumn :allow-editing="false" caption="Gói cước" data-field="Package"/>
      <DxColumn caption="ICCID" data-field="ICCID"/>
      <DxColumn :allow-editing="false" caption="Mã kích hoạt" data-field="Code"/>
      <DxColumn :allow-editing="false" caption="ESIM" data-field="ESIM" data-type="boolean"/>
      <!--      <DxColumn-->
      <!--          type="buttons"-->
      <!--      >-->
      <!--        <DxGridButton-->
      <!--            name="edit"-->
      <!--            icon="fa-solid fa-sim-card"-->
      <!--            :disabled="isKITDisabled"-->
      <!--        />-->
      <!--      </DxColumn>-->
    </DxDataGrid>
  </div>
</template>
<script>
import {DxButton as DxGridButton, DxColumn, DxDataGrid, DxEditing} from 'devextreme-vue/data-grid';
import {DxButton} from 'devextreme-vue/button';
import DataSource from 'devextreme/data/data_source';
import CustomStore from "devextreme/data/custom_store";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    DxDataGrid, DxColumn, DxButton, DxEditing, DxGridButton,
  },
  name: 'OrderDetail',
  props: {
    templateData: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    getTasks(key) {
      console.log(key)
      return new DataSource({
        store: new CustomStore({
          key: "Id",
          loadMode: "raw",
          load: () => {
            return useJwt.get('order/detail/' + key).then(response => {
              return response.data.result;
            }).catch(error => {
              return []
            })
          },
          update: (key, values) => {
            console.log(key)
            console.log(values)
          }
        }),
      });
    }
  },
  mounted() {
    this.dataSource = this.getTasks(this.templateData.key)
  },
  data() {
    return {
      dataSource: {},
      isKITDisabled: (e) => {
        return e.row.data.ICCID || e.row.data.ESIM
      }
    }
  }
}
</script>
